/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EloshieldClassicStationaryModuleCreate
 */
export interface EloshieldClassicStationaryModuleCreate {
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModuleCreate
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModuleCreate
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof EloshieldClassicStationaryModuleCreate
     */
    antennaACount: number;
    /**
     * 
     * @type {number}
     * @memberof EloshieldClassicStationaryModuleCreate
     */
    antennaBCount: number;
}

/**
 * Check if a given object implements the EloshieldClassicStationaryModuleCreate interface.
 */
export function instanceOfEloshieldClassicStationaryModuleCreate(value: object): value is EloshieldClassicStationaryModuleCreate {
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('antennaACount' in value) || value['antennaACount'] === undefined) return false;
    if (!('antennaBCount' in value) || value['antennaBCount'] === undefined) return false;
    return true;
}

export function EloshieldClassicStationaryModuleCreateFromJSON(json: any): EloshieldClassicStationaryModuleCreate {
    return EloshieldClassicStationaryModuleCreateFromJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EloshieldClassicStationaryModuleCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'serialNumber': json['serialNumber'],
        'label': json['label'],
        'antennaACount': json['antennaACount'],
        'antennaBCount': json['antennaBCount'],
    };
}

export function EloshieldClassicStationaryModuleCreateToJSON(json: any): EloshieldClassicStationaryModuleCreate {
    return EloshieldClassicStationaryModuleCreateToJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleCreateToJSONTyped(value?: EloshieldClassicStationaryModuleCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serialNumber': value['serialNumber'],
        'label': value['label'],
        'antennaACount': value['antennaACount'],
        'antennaBCount': value['antennaBCount'],
    };
}

